import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsOpenedOrdersEnum } from '../../enums/stocks/columns-opened-orders.enum'

export const ColumnsOpenedOrdersConstant: ColumnInterface<ColumnsOpenedOrdersEnum>[] = [
	{
		column: ColumnsOpenedOrdersEnum.tickerCompany,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.operation,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.quantity,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.orderType,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.price,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.term,
		visible: true,
	},
	{
		column: ColumnsOpenedOrdersEnum.statusTitle,
		visible: true,
	},
]
